import discover from '../views/discover/Index.vue'

const discoverRouter = [
  {
    path: '/',
    name: 'discover',
    component: discover
  }
]
export default discoverRouter